import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'
import { Button } from '@/components/ui/button.jsx'

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      className="relative p-2 h-10 w-10 rounded-md border border-ap-blurple/30 bg-transparent hover:bg-ap-blurple/10 transition-all duration-200 ap-glow-blurple"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <Sun 
        className={`h-4 w-4 absolute inset-0 m-auto rotate-0 scale-100 transition-all duration-300 ${
          theme === 'dark' ? 'rotate-90 scale-0' : ''
        } text-ap-blurple`}
      />
      <Moon 
        className={`h-4 w-4 absolute inset-0 m-auto rotate-90 scale-0 transition-all duration-300 ${
          theme === 'dark' ? 'rotate-0 scale-100' : ''
        } text-ap-blurple`}
      />
    </Button>
  )
}

export default ThemeToggle